import { FaRegCheckSquare } from "react-icons/fa";
import { PeriodProvider } from "@/providers/Period";
import { lazy, Suspense } from "react";

const VendedoresList = lazy(() => import("./Vendedores/List").then((m) => ({ default: m.VendedoresList })));
const Gestao = lazy(() => import("./Gestao").then((m) => ({ default: m.Gestao })));
const Operacional = lazy(() => import("./Operacional").then((m) => ({ default: m.Operacional })));
const PainelExpedicao = lazy(() => import("./Painel").then((m) => ({ default: m.PainelExpedicao })));
const ItensPedidos = lazy(() => import("./Gestao/children/ItensPedidos").then((m) => ({ default: m.ItensPedidos })));
const GestaoExpedicao = lazy(() => import("./GestaoExpedicao"));
const PainelPedidos = lazy(() => import("./PainelPedidos"));
const RelatorioExpedicao = lazy(() => import("./RelatorioExpedicao"));
const ExpedicaoRegioes = lazy(() => import("./Regioes"));
const ExpedicaoRotas = lazy(() => import("./Rotas"));
const ExpedicaoClientes = lazy(() => import("./Clientes"));
const DetalhesClientes = lazy(() => import("./Clientes/Components/Details").then((m) => ({ default: m.DetalhesClientes })));
const ExpedicaoTransportadoras = lazy(() => import("./Transportadoras"));
const DetalhesTransportadoras = lazy(() => import("./Transportadoras/Components/Details").then((m) => ({ default: m.DetalhesTransportadoras })));
const DetalhesVeiculoTransportadoras = lazy(() => import("./VeiculosDeTransportadoras/Components/Details").then((m) => ({ default: m.DetalhesVeiculoTransportadoras })));
const ExpedicaoVeiculoTransportadoras = lazy(() => import("./VeiculosDeTransportadoras"));
const GeracaoPedido = lazy(() => import("./GeracaoPedido"));
const Notas = lazy(() => import("./GeracaoPedido/Notas"));
const Itens = lazy(() => import("./GeracaoPedido/Itens"));
const Resumo = lazy(() => import("./GeracaoPedido/Resumo"));
const ComparacaoPedidos = lazy(() => import("./ComparacaoPedidos"));
const VisualizarRelatorioModal = lazy(() => import("./ComparacaoPedidos/Components/ModalVisualizar"));
const LiberacaoEmbarque = lazy(() => import("./LiberacaoEmbarque"));
const GestaoEmbarque = lazy(() => import("./GestaoEmbarque"));
const EmConferencia = lazy(() => import("./Conferencia/components/EmConferencia"));
const Conferencia = lazy(() => import("./Conferencia"));
const RelatorioPainelExpedicao = lazy(() => import("./RelatorioPainelExpedicao").then((m) => ({ default: m.RelatorioPainelExpedicao })));
const ExpedicoesDashboard = lazy(async () => import('./Dashboard'));

const Module = {
  menuItem: {
    to: "/expedicoes",
    title: "Expedições",
    icon: FaRegCheckSquare,
    id: 13,
    childrens: [
      {
        to: "/expedicoes/dash",
        title: "Dashboard",
        fullTitle: "Dashboard",
        id: 31
      },
      {
        to: "/expedicoes/gestao-expedicao",
        title: "Gestao",
        fullTitle: "Gestao",
        id: 32
      },
      {
        to: "/expedicoes/conferencia",
        title: "Conferência",
        fullTitle: "Conferência",
        id: 33
      },
      {
        to: "/expedicoes/relatorio-expedicao",
        title: "Rel. Expedição",
        fullTitle: "Relatório de Expedição",
        id: 34
      },
      {
        to: "/expedicoes/consulta-de-regioes",
        title: "Regiões",
        fullTitle: "Consulta de Regiões",
        id: 36
      },
      {
        to: "/expedicoes/consulta-de-rotas",
        title: "Rotas",
        fullTitle: "Consulta de Rotas",
        id: 42
      },
      {
        to: "/expedicoes/consulta-de-clientes",
        title: "Clientes",
        fullTitle: "Consulta de Clientes",
        id: 47
      },
      {
        to: "/expedicoes/consulta-de-transportadoras",
        title: "Transportadoras",
        fullTitle: "Consulta de Transportadoras",
        id: 53
      },
      {
        to: "/expedicoes/consulta-de-veiculos-de-transportadoras",
        title: "Veículos",
        fullTitle: "Consulta de Veículo Transportadora",
        id: 54
      },
      {
        to: "/expedicoes/painel-pedido",
        title: "Painel Pedidos",
        fullTitle: "Painel de Pedidos",
        id: 55
      },
      {
        to: "/expedicoes/geracao-de-pedidos",
        title: "Gerar Pedidos",
        fullTitle: "Gerar Pedidos",
        id: 80
      },
      {
        to: "/expedicoes/comparacao-pedidos",
        title: "Comparação Pedidos",
        fullTitle: "Comparação Pedidos",
        id: 56
      },
      {
        to: "/expedicoes/relatorio-painel-expedicao",
        title: "Painel Expedição",
        fullTitle: "Painel Expedição",
        id: 57
      },
    ],
  },

  routes: [
    {
      path: "/expedicoes/gestao-expedicao",
      element: (
        <PeriodProvider>
          <GestaoExpedicao />
        </PeriodProvider>
      ),
      children: [
        {
          path: ":tipo/:id", element: <ItensPedidos />
        }
      ]
    },
    {
      path: "/expedicoes/gestao-expedicao1",
      element: (
        <PeriodProvider>
          <Gestao />
        </PeriodProvider>
      ),
      children: [
        {
          path: ":tipo/:id", element: <ItensPedidos />
        }
      ]
    },
    {
      path: "/expedicoes",
      element: (
        <PainelExpedicao />
      ),
    },
    {
      path: "/expedicoes/conferencia",
      element: (
        <PeriodProvider >
          <Conferencia />
        </PeriodProvider>
      ),
      children: [
        {
          path: ':id/:idEstacao',
          element: <EmConferencia />

        },
      ]
    },
    {
      path: "/expedicoes/relatorio-expedicao",
      element: (
        <RelatorioExpedicao />
      ),
    },
    {
      path: "/expedicoes/operacional",
      element: (
        <PeriodProvider>
          <Operacional />
        </PeriodProvider>
      ),
    },
    {
      path: "/expedicoes/dash",
      element:
        <Suspense fallback={<><div style={{
          background: '#ccc',
          height: '100vh',
          width: '100vw'
        }} />...</>}>
          <PeriodProvider>
            <ExpedicoesDashboard />
          </PeriodProvider>
        </Suspense>
    },
    {
      path: "expedicoes/consulta-de-regioes",
      element: <ExpedicaoRegioes />,
    },
    {
      path: "expedicoes/consulta-de-rotas",
      element: <ExpedicaoRotas />,
    },
    {
      path: "expedicoes/consulta-de-clientes",
      element: <ExpedicaoClientes />,
      children: [{ path: ":id", element: <DetalhesClientes /> }],
    },
    {
      path: "expedicoes/consulta-de-vendedores",
      element: <VendedoresList />,
    },
    {
      path: "expedicoes/consulta-de-transportadoras",
      element: <ExpedicaoTransportadoras />,
      children: [{ path: ":id", element: <DetalhesTransportadoras /> }],
    },
    {
      path: "expedicoes/consulta-de-veiculos-de-transportadoras",
      element: <ExpedicaoVeiculoTransportadoras />,
      children: [{ path: ":id", element: <DetalhesVeiculoTransportadoras /> }],
    },
    {
      path: "expedicoes/painel-pedido",
      element: <PainelPedidos />,
    },
    {
      path: "/expedicoes/geracao-de-pedidos",
      element: <PeriodProvider><GeracaoPedido /></PeriodProvider>,
      children: [
        {
          path: "",
          element: <Notas />
        },
        {
          path: ":notaId/itens",
          element: <Itens />
        },
        {
          path: ":notaId/resumo",
          element: <Resumo />
        }
      ]
    },
    {
      path: "/expedicoes/comparacao-pedidos",
      element: <PeriodProvider>
        <ComparacaoPedidos />
      </PeriodProvider>,
      children: [{ path: ":id", element: <VisualizarRelatorioModal /> }],
    },
    {
      path: "/expedicoes/liberacao-embarque",
      element: <PeriodProvider>
        <LiberacaoEmbarque />
      </PeriodProvider>,
    },
    {
      path: "/expedicoes/gestao-embarque",
      element: <PeriodProvider>
        <GestaoEmbarque />
      </PeriodProvider>,
    },
    {
      path: "/expedicoes/relatorio-painel-expedicao",
      element: <RelatorioPainelExpedicao />
    },
  ],
};

export default Module;
